<template>
    <section class="article">
        <div class="container article">
            <div class="article__public-offer-item">
                <div><strong>{{ trans('po1')}}</strong></div>
                <div><strong><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">{{ trans('po2')}}: </font></font><a href="mailto:arendaipzakharova@yandex.ru" class="article__link"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">arendaipzakharova@yandex.ru</font></font></a></strong>
                </div>
                <div>
                    <strong>{{ trans('po3')}}: <a href="tel:+79308860575" class="article__link">+7 930 886 0575</a></strong>
                </div>
            </div>
            <p class="article__public-offer-item">
                {{ trans('po5')}}
            </p>
            <div class="article__public-offer-item"><strong>1.{{ trans('po7')}}</strong>
                <div class="article__public-offer-sub-item"><strong>1.1.</strong> {{ trans('po8')}}
                    <a href="https://batnorton.com" class="article__link">https://batnorton.com</a>
                </div>
                <div class="article__public-offer-sub-item"><strong>1.2.</strong>
                    {{ trans('po9')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>1.3.</strong>
                    {{ trans('po10')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>1.4.</strong>
                    {{ trans('po11')}}:
                    <ul class="article__list">
                        <li>
                            {{ trans('po12')}}.
                        </li>
                        <li>
                            {{ trans('po13')}}.
                        </li>
                        <li>
                            {{ trans('po14')}}.
                        </li>
                        <li>
                            {{ trans('po15')}}.
                        </li>
                        <li>
                            {{ trans('po16')}}.
                        </li>
                        <li>
                            {{ trans('po17')}}.
                        </li>
                    </ul>
                </div>
            </div>
            <div class="article__public-offer-item"><strong>2. {{ trans('po18')}}</strong>
                <div class="article__public-offer-sub-item"><strong>2.1.</strong>
                    {{ trans('po19')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>,
                    {{ trans('po20')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>2.2.</strong>
                    {{ trans('po21')}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong>3. {{ trans('po22')}}</strong>
                <div class="article__public-offer-sub-item"><strong>3.1.</strong>
                    {{ trans('po23')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>
                </div>
                <div class="article__public-offer-sub-item"><strong>3.2.</strong>
                    {{ trans('po24')}}:
                    <ul class="article__list">
                        <li>{{ trans('po25')}}, {{ trans('po26')}},</li>
                        <li>{{ trans('po26')}} .&nbsp;</li>
                        <li>{{ trans('po27')}};</li>
                        <li>{{ trans('po28')}};</li>
                        <li>{{ trans('po29')}}.</li>
                    </ul>
                </div>
                <div class="article__public-offer-sub-item"><strong>3.3.</strong> {{ trans('po30')}}. <strong>3.2.</strong>
                    {{ trans('po31')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>
                    {{ trans('po32')}}.
                    <strong>3.2.</strong>
                    {{ trans('po33')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.4.</strong>
                    {{ trans('po34')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.5.</strong>
                    {{ trans('po35')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.6.</strong>
                    {{ trans('po36')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.7.</strong>
                    {{ trans('po37')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>,
                    {{ trans('po38')}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong>4. {{ trans('po39')}}</strong>
                <div class="article__public-offer-sub-item"><strong>4.1.</strong>
                    {{ trans('po40')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>4.2.</strong>
                    {{ trans('po41')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>4.3.</strong>
                    {{ trans('po42')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>4.4.</strong>
                    {{ trans('po43')}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong>5. {{ trans('po44')}}</strong>
                <div class="article__public-offer-sub-item"><strong>5.1.</strong>
                    {{ trans('po45')}}
                    {{ trans('po46')}}
                    {{ trans('po47')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>5.2.</strong>
                    {{ trans('po48')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>,
                    {{ trans('po49')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>5.3.</strong>
                    {{ trans('po50')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>5.4.</strong>
                    {{ trans('po51')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>
                    {{ trans('po52')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>5.5.</strong>
                    {{ trans('po53')}}
                </div>
            </div>
            <div class="article__public-offer-item"><strong>6. {{ trans('po54')}}.</strong>
                <div class="article__public-offer-sub-item"><strong>6.1.</strong>
                    {{ trans('po55')}}
                </div>
                <div class="article__public-offer-sub-item"><strong>6.2.</strong>
                    {{ trans('po56')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>6.3.</strong> {{ trans('po57')}}
                    <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>.
                </div>
            </div>
            <div class="article__public-offer-item"><strong>7. {{ trans('po58')}}</strong>
                <div class="article__public-offer-sub-item"><strong>7.1.</strong>
                    {{ trans('po59')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>7.2.</strong>
                    {{ trans('po60')}}.
                    <p>{{ trans('po61')}}.</p>
                    <p>{{ trans('po62')}}.</p>
                    <p>{{ trans('po63')}}.</p>
                </div>

                <div class="article__public-offer-sub-item"><strong>7.3.</strong>
                    {{ trans('po64')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>7.4.</strong>
                    {{ trans('po65')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>7.5.</strong>
                    {{ trans('po66')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>7.6.</strong>
                    {{ trans('po67')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>7.7.</strong>
                    {{ trans('po68')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>,
                    {{ trans('po69')}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong>8. {{ trans('po70')}}</strong>
                <div class="article__public-offer-sub-item"><strong>8.1.</strong>
                    {{ trans('po71')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>8.2.</strong>
                    {{ trans('po72')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>8.3.</strong>
                    {{ trans('po73')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>8.4.</strong>
                    {{ trans('po74')}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>8.5.</strong>
                    {{ trans('po75')}} <a class="article__link" href="https://batnorton.com">https://batnorton.com</a>,
                    {{ trans('po76')}} <a class="article__link" href="https://batnorton.com/contacts">https://batnorton.com/contacts</a>.
                    {{ trans('po77')}}.
                </div>
            </div>
            <p class="article__public-offer">
                <strong>{{ trans('po78')}}</strong>
            </p>
            <div class="Article__publicoffer">
                <div><strong>{{ trans('po79')}}</strong></div>
                <div><strong>{{ trans('po91')}}: 326330000023853</strong></div>
                <div><strong>{{ trans('po80')}}: 331700720148</strong></div>
                <div><strong>{{ trans('po87')}}</strong></div>
                <div><strong>{{ trans('po93')}}</strong></div>
                <div><strong>{{ trans('po82')}}: 40802810032230008497</strong></div>
                <div><strong>{{ trans('po83')}}</strong></div>
                <div><strong>{{ trans('po84')}}: 30101810600000000786</strong></div>
                <div><strong>{{ trans('po85')}}: 044030786</strong></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
